import { Component } from "react";
import ServiceCard from "./ServiceCard";
import './Services.css';
import iconBusiness from '../images/icon-business.png';
import iconInfrastructure from '../images/icon-infrastructure.png';
import iconWeb from '../images/icon-web.png';
import iconSoftware from '../images/icon-software.png';
import iconMobile from '../images/icon-mobile.png';
import iconTraining from '../images/icon-training.png';
import iconSecurity from '../images/icon-security.png';
import iconMaintenance from '../images/icon-maintenance.png';
import iconOutsource from '../images/icon-outsource.png';

class Services extends Component{
    render(){
        return(
            <div className="Services container-fluid" id="services">
                <div className="sub-heading">
                    <h3>SERVICES</h3>
                </div>
                <div className="wrapper">
                    <p className="words">ANA IT Solutions Inc. offers full range of services in the IT domain starting from business analysis, project management, architecture designing and custom development as well as database development and management.</p>
                    <p className="words">We provide complete solutions to empower your business and capitalise on available opportunities.</p>
                    <div className="service-container">
                        <ServiceCard title="Business Process Solution" pic={iconBusiness}/>
                        <ServiceCard title="Infrastructure" pic={iconInfrastructure}/>
                        <ServiceCard title="Web Solutions" pic={iconWeb}/>
                    </div>
                    <p className="words">ANA IT Solutions Inc. considers every technology at our disposal to create a proposition that reflects your company's vision, is easy to use, reliable and positively enhances the way you do business.</p>
                    <div className="service-container">
                        <ServiceCard title="Software Development" pic={iconSoftware}/>
                        <ServiceCard title="Mobile Solutions" pic={iconMobile}/>
                        <ServiceCard title="Training" pic={iconTraining}/>
                    </div>
                    <p className="words">Careful planning at all stages lays the groundwork for future developments, and allows you to integrate technology at your own speed.</p>
                    <div className="service-container">
                        <ServiceCard title="Security" pic={iconSecurity}/>
                        <ServiceCard title="Maintenance" pic={iconMaintenance}/>
                        <ServiceCard title="Strategic Outsourcing" pic={iconOutsource}/>
                    </div>
                    <p className="words">Our expertise are extended towards mobile development, offering custom solutions for mobile devices with secured transfer of sensitive information over the network.</p>
                    <p className="words">We have proven record of delivering best quality results complying IT standards like CMMI and ISO.</p>
                </div>
            </div>
        )
    }
}

export default Services;